import { useMutation } from '@tanstack/react-query';

import { authApi, type ResendAccountActivationRequest } from '@/api/routes/public/auth.api';
import { translateFile } from '@/i18n';

export const useResendAccountActivation = () =>
  useMutation({
    mutationFn: (data: ResendAccountActivationRequest) => authApi.resendAccountActivation(data),
    meta: {
      showUserMessage: false,
      defaultUserMessage: translateFile('api.hooks.public.useResendAccountActivation', 'error'),
    },
  });
